






















































import {Component, Vue} from "vue-property-decorator";
import VueRecaptcha from 'vue-recaptcha';
import Checking from "@/modules/checking/index.vue";
import AInputBarCode from "@/shared/components/InputBarCode/index.vue";
import {DeviceType} from "@/enums/type";
import {AppModule} from "@/store/modules/app";
import {guestGetChecking, guestGetTracking} from "@/modules/guest/checkings/services";

@Component({
    name: "LayoutAuth",
    components: {Checking, AInputBarCode, VueRecaptcha}
})
export default class extends Vue {
    deviceType = DeviceType;
    ladingCode = "";
    checkings = [] as any;
    visibleModal = false;
    sitekey = process.env.VUE_APP_CAPTCHA_KEY

    get device() {
        return AppModule.device;
    }

    closeModal() {
        this.visibleModal = false;
        this.ladingCode = "";
    }

    validateCaptcha() {
        (this.$refs.recaptcha as any).execute()
    }

    resetCaptcha() {
        (this.$refs.recaptcha as any).reset()
    }

    async onCaptchaVerified(recaptchaToken) {
        this.resetCaptcha()
        const trackingDatas = "";
        let checkingDatas = [] as any;
        const ladingCode = this.ladingCode;
        if (!ladingCode) return;
        try {
            await guestGetChecking(ladingCode, recaptchaToken).then(response => response.json()).then(data => {
                checkingDatas = data
            })
            // await guestGetTracking(ladingCode, recaptchaToken).then(response => response.json()).then(data => {
            //     for (const i in data) {
            //         data[i].createdDate = new Date(data[i].ladingDate).toLocaleTimeString('vi-vn', {
            //             hour: '2-digit',
            //             minute: '2-digit'
            //         }) + ' ' + new Date(data[i].ladingDate).toLocaleDateString('vi-vn', {
            //             day: '2-digit',
            //             month: '2-digit',
            //             year: 'numeric'
            //         });
            //         data[i].updatedDate = new Date(data[i].ladingDate).toLocaleTimeString('vi-vn', {
            //             hour: '2-digit',
            //             minute: '2-digit'
            //         }) + ' ' + new Date(data[i].ladingDate).toLocaleDateString('vi-vn', {
            //             day: '2-digit',
            //             month: '2-digit',
            //             year: 'numeric'
            //         });
            //     }
            //     trackingDatas = data
            // }).catch((error) => {
            //     console.error(error);
            // });
            if (!trackingDatas) {
                this.checkings = checkingDatas;
            } else {
                this.checkings = checkingDatas.concat(trackingDatas);
            }
            this.visibleModal = true;
        } catch (e) {
            this.$message.error(e?.response?.data?.message || "Checking thất bại");
        }
    }
}
